import format from 'date-fns/format';
import req from 'utils/req';
import { z } from 'zod';

export const DateRangeSchema = z.object({
  from: z.coerce.date(),
  to: z.coerce.date().optional(),
});

type DateRange = z.infer<typeof DateRangeSchema>;

const HostAvailabilityByDurationResponseSchema = z.array(
  z.object({
    date: z.coerce.date(),
    times: z.array(z.string()),
  }),
);

export const fetchHostAvailabilityByDuration = async (
  accountId: string,
  duration: number,
  dateRange: DateRange,
) => {
  if (!accountId) {
    return [];
  }
  const searchParams = new URLSearchParams();
  const fromDate = format(dateRange.from, 'yyyy-MM-dd');
  const toDate = dateRange.to ? format(dateRange.to, 'yyyy-MM-dd') : fromDate;
  searchParams.set('from', fromDate);
  searchParams.set('to', toDate);

  const response = await req(
    `${URL_API_HOST}/api/v2/agenda/host/availability/${accountId}/duration/${duration}?${searchParams.toString()}`,
  ).get();

  return HostAvailabilityByDurationResponseSchema.parse(response);
};

const AvailableHostsByDurationResponseSchema = z.object({
  availableHosts: z.array(z.string().uuid()),
});

export const fetchAvailableHostsInAreaByDuration = async (
  area: string,
  date: Date,
  time: string,
  duration: number,
) => {
  const searchParams = new URLSearchParams();
  searchParams.set('start_date_time', format(date, 'yyyy-MM-dd') + 'T' + time);
  searchParams.set('area', area);

  const response = await req(
    `${URL_API_HOST}/api/v2/agenda/host/availability/duration/${duration}/params?${searchParams.toString()}`,
  ).get();

  return AvailableHostsByDurationResponseSchema.parse(response);
};
